import { StatusMapper } from 'types/settings/internalConfig';

export const getStatusOptionsFromMapper = (
  mapper: StatusMapper | null
): Array<{ label: string; value: string }> => {
  if (!mapper) return [];
  return mapper.mappings.map((mapping) => ({
    label: mapping.status,
    value: mapping.status,
  }));
};
